/**
 * Las rutas del proceso de alta y de baja, en UN sitio.
 *
 * Las usan `App.js` (la declaración), los dos listados, las dos páginas y la ficha de la persona.
 * Escribirlas a mano en cada uno es como acabó una ruta mal escrita que React Router no casaba y
 * no avisaba: la pantalla salía en blanco (ver el comentario de `?alta=` en `Incorporaciones.jsx`
 * en su historia). Con el patrón y el constructor juntos, no pueden divergir.
 */
export const RUTA_EMBUDO = '/gestionpersonas/personas/incorporaciones';
export const RUTA_BAJAS = '/gestionpersonas/personas/bajas';

// Los patrones que declara `App.js`.
export const PATRON_ALTA = `${RUTA_EMBUDO}/altas/:id`;
export const PATRON_BAJA = `${RUTA_BAJAS}/:id`;

// Y lo que se navega.
export const rutaAlta = (id) => `${RUTA_EMBUDO}/altas/${id}`;
export const rutaBaja = (id) => `${RUTA_BAJAS}/${id}`;

// La ficha de la persona: interna y colaboradora tienen rutas distintas.
export const rutaFicha = (ambito, personaId) => (ambito === 'colaborador'
  ? `/gestionpersonas/personas-colaboradoras/editarColaborador/${personaId}`
  : `/gestionpersonas/personas/editarPersona/${personaId}`);

/* La ficha, en Personal, sabiendo a qué proceso volver (pieza 2). `volver` lo valida la ficha
 * con `rutaDeVuelta` antes de usarlo: aquí sólo se construye. */
export const rutaFichaConVuelta = (ambito, personaId, volver) =>
  `${rutaFicha(ambito, personaId)}?tab=personal&volver=${encodeURIComponent(volver)}`;

/* La marca que deja el proceso al mandarte a la ficha NAVEGANDO. Con ella, volver es
 * `navigate(-1)`: el historial queda «listado → proceso», y el «Volver» del proceso sigue llevando
 * al listado. Sin ella (la URL se pegó o se abrió en otra pestaña) se navega a `volver`. */
export const ESTADO_DESDE_PROCESO = { vueltaPorHistorial: true };
